import { render } from "./LegalSidebar.vue?vue&type=template&id=6e8a4f2e&scoped=true"
import script from "./LegalSidebar.vue?vue&type=script&lang=js"
export * from "./LegalSidebar.vue?vue&type=script&lang=js"

import "./LegalSidebar.vue?vue&type=style&index=0&id=6e8a4f2e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8a4f2e"]])

export default __exports__